module.exports = __webpack_public_path__ + "img/6.76426e20.jpg";